import React from 'react';
import { Link } from 'react-router-dom';
import { LegalLinkItems } from '../legal/legalLinks';

export const CONSULTATION_PREFILL_KEY = 'anylex_support_prefill';

function AppFooter({ onOpenCookieSettings, setActiveSection, setSettingsTab }) {
    const currentYear = new Date().getFullYear();

    const handleConsultationClick = () => {
        try {
            sessionStorage.setItem(CONSULTATION_PREFILL_KEY, JSON.stringify({
                ticket_type: 'support',
                subject: 'Персональная консультация',
                priority: 'normal',
            }));
        } catch (e) {
            // sessionStorage unavailable — ticket form will just open empty
        }
        if (setActiveSection) setActiveSection('settings');
        if (setSettingsTab) setSettingsTab('support');
    };

    return (
        <footer className="footer">
            <div className="footer__nav">
                <div className="footer__brand">
                    <h3>Энилекс. Контроль.</h3>
                    <p>Панель для профессионалов на маркетплейсах.</p>
                    <p className="footer__company">ООО «Энилекс»</p>
                </div>
                <div>
                    <p className="footer__title">Возможности</p>
                    <ul>
                        <li>Интеграция OZON и Wildberries</li>
                        <li>Массовое редактирование товаров</li>
                        <li>Аналитика и отчеты</li>
                        <li>Командная работа</li>
                    </ul>
                </div>
                <div>
                    <p className="footer__title">Поддержка</p>
                    <ul>
                        <li>
                            <a href="mailto:control@anylex.ru">control@anylex.ru</a>
                        </li>
                        <li>
                            <button
                                type="button"
                                className="footer__text-button footer__accent"
                                onClick={handleConsultationClick}
                            >
                                Персональные консультации
                            </button>
                        </li>
                    </ul>
                </div>
                <div>
                    <p className="footer__title">Бесплатные инструменты</p>
                    <ul>
                        <li>
                            <Link to="/free-functions">Все инструменты</Link>
                        </li>
                        <li>
                            <Link to="/free-functions/barcode">Создание ШК и QR</Link>
                        </li>
                        <li>
                            <Link to="/free-functions/ozon-fbs-labels">Сортировка FBS-этикеток Ozon</Link>
                        </li>
                        <li>
                            <Link to="/free-functions/ai-generator">AI-генератор названий и описаний</Link>
                        </li>
                    </ul>
                </div>
                <div>
                    <p className="footer__title">Документы</p>
                    <ul>
                        <LegalLinkItems as="li" />
                        <li>
                            <button
                                type="button"
                                className="footer__text-button"
                                onClick={onOpenCookieSettings}
                            >
                                Настройки cookie
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="footer__meta">
                <div className="footer__copyright">
                    <span>&copy; {currentYear} ООО «Энилекс»</span>
                    <span>ИНН 7733357420 | ОГРН 1207700268214</span>
                </div>
                <div className="footer__links">
                    <a href="mailto:control@anylex.ru">control@anylex.ru</a>
                </div>
            </div>
        </footer>
    );
}

export default AppFooter;
